
function getStorage(key) {
    try {
        return localStorage.getItem(key);
    } catch (error) {
        return null;
    }
}

function setStorage(key, value) {
    try {
        localStorage.setItem(key, value);
    } catch (error) {
    }
}

function formatNumber(num) {
    if (num < 10) {
        return '0' + num;
    }
    return '' + num;
}

class PromotionalPopup extends HTMLElement {
    connectedCallback() {
        this.dialog = this.querySelector('.vwpopup__dialog');
        if (!this.dialog) return;
        this.triggerType = this.getAttribute('data-trigger') || 'delay';
        const delaySeconds = parseInt(this.getAttribute('data-delay') || '3', 10);
        this.delayMs = (isNaN(delaySeconds) ? 3 : delaySeconds) * 1000;
        const scrollPct = parseInt(this.getAttribute('data-scroll-percentage') || '20', 10);
        this.scrollPercentage = isNaN(scrollPct) ? 20 : Math.min(Math.max(scrollPct, 10), 50);
        this.frequency = this.getAttribute('data-frequency') || 'once';
        const customHours = parseFloat(this.getAttribute('data-reappear-hours') || '24');
        this.reappearHours = isNaN(customHours) || customHours <= 0 ? 24 : customHours;

        const id = this.id || 'default';
        this.storageKeyOnce = 'vwpopup_seen_' + id;
        this.storageKeyClosed = 'vwpopup_closed_' + id;

        this.popupTimer = null;
        this.previousFocusElement = null;

        this.initPopup();
        this.attachEvents();
    }

    disconnectedCallback() {
        clearTimeout(this.popupTimer);

        if (this.handleScrollTrigger) {
            window.removeEventListener('scroll', this.handleScrollTrigger);
            window.removeEventListener('resize', this.handleScrollTrigger);
        }

        if (this.handleKeyDown) {
            document.removeEventListener('keydown', this.handleKeyDown);
        }
        if (this.handleTouchMove) {
            this.removeEventListener('touchmove', this.handleTouchMove);
        }
        if (this.handleWheel) {
            this.removeEventListener('wheel', this.handleWheel);
        }

        const otherOpenPopup = document.querySelector('promotional-popup[open]');
        if (!otherOpenPopup) {
            document.documentElement.classList.remove('overflow-hidden');
            document.body.classList.remove('overflow-hidden');
        }
    }

    initPopup() {
        if (this.hasAttribute('open')) return;

        if (this.shouldShowPopup()) {
            if (this.triggerType === 'scroll') {
                this.initScrollTrigger();
            } else {
                this.popupTimer = setTimeout(() => {
                    this.openPopup();
                }, this.delayMs);
            }
        }
    }

    initScrollTrigger() {
        let ticking = false;

        this.handleScrollTrigger = () => {
            if (this.hasAttribute('open')) {
                window.removeEventListener('scroll', this.handleScrollTrigger);
                window.removeEventListener('resize', this.handleScrollTrigger);
                return;
            }

            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
                    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
                    const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

                    if (scrollPercent >= this.scrollPercentage) {
                        window.removeEventListener('scroll', this.handleScrollTrigger);
                        window.removeEventListener('resize', this.handleScrollTrigger);
                        this.openPopup();
                    }
                    ticking = false;
                });
                ticking = true;
            }
        };

        window.addEventListener('scroll', this.handleScrollTrigger, { passive: true });
        window.addEventListener('resize', this.handleScrollTrigger, { passive: true });
        this.handleScrollTrigger();
    }

    shouldShowPopup() {
        if (this.hasAttribute('open')) return false;

        if (this.frequency === 'once') {
            return getStorage(this.storageKeyOnce) !== 'true';
        }

        if (this.frequency === 'hours' || this.frequency === '24_hours') {
            const lastClosed = getStorage(this.storageKeyClosed);
            if (!lastClosed) {
                return true;
            }

            const hoursPassed = (Date.now() - Number(lastClosed)) / (1000 * 60 * 60);
            return hoursPassed >= this.reappearHours;
        }

        return true;
    }

    openPopup() {
        if (this.handleScrollTrigger) {
            window.removeEventListener('scroll', this.handleScrollTrigger);
            window.removeEventListener('resize', this.handleScrollTrigger);
        }
        clearTimeout(this.popupTimer);

        this.previousFocusElement = document.activeElement;
        this.removeAttribute('inert');
        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('overflow-hidden');

        if (this.frequency === 'once') {
            setStorage(this.storageKeyOnce, 'true');
        }

        const button = this.querySelector('.vwpopup__cta-btn') || this.querySelector('.vwpopup__close');
        if (button) {
            button.focus({ preventScroll: true });
        }
    }

    closePopup() {
        if (!this.hasAttribute('open')) return;

        if (this.contains(document.activeElement)) {
            document.activeElement.blur();
        }

        if (this.previousFocusElement && typeof this.previousFocusElement.focus === 'function') {
            this.previousFocusElement.focus({ preventScroll: true });
        }

        this.removeAttribute('open');
        this.setAttribute('aria-hidden', 'true');
        this.setAttribute('inert', '');

        const otherOpenPopup = document.querySelector('promotional-popup[open]');
        if (!otherOpenPopup) {
            document.documentElement.classList.remove('overflow-hidden');
            document.body.classList.remove('overflow-hidden');
        }

        if (this.handleScrollTrigger) {
            window.removeEventListener('scroll', this.handleScrollTrigger);
            window.removeEventListener('resize', this.handleScrollTrigger);
        }
        clearTimeout(this.popupTimer);
        if (this.frequency === 'once') {
            setStorage(this.storageKeyOnce, 'true');
        } else {
            setStorage(this.storageKeyClosed, Date.now().toString());
        }
    }


    handleFocusTrap(event) {
        const focusable = this.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    attachEvents() {
        this.addEventListener('click', (event) => {
            if (event.target.closest('[data-action="close"]')) {
                event.preventDefault();
                this.closePopup();
            }
        });

        this.handleKeyDown = (event) => {
            if (!this.hasAttribute('open')) return;

            if (event.key === 'Escape') {
                this.closePopup();
            } else if (event.key === 'Tab') {
                this.handleFocusTrap(event);
            }
        };
        document.addEventListener('keydown', this.handleKeyDown);

        this.handleTouchMove = (event) => {
            if (!this.hasAttribute('open')) return;
            if (event.touches && event.touches.length > 1) {
                return;
            }

            if (!event.target.closest('.vwpopup__dialog')) {
                event.preventDefault();
            }
        };
        this.addEventListener('touchmove', this.handleTouchMove, { passive: false });

        this.handleWheel = (event) => {
            if (!this.hasAttribute('open')) return;

            if (event.ctrlKey) {
                event.preventDefault();
                return;
            }

            if (!event.target.closest('.vwpopup__dialog')) {
                event.preventDefault();
            }
        };
        this.addEventListener('wheel', this.handleWheel, { passive: false });

        if (window.Shopify && window.Shopify.designMode) {
            const section = this.closest('.shopify-section');
            if (section) {
                section.addEventListener('shopify:section:select', () => this.openPopup());
                section.addEventListener('shopify:section:deselect', () => this.closePopup());
            }
        }
    }
}

if (!customElements.get('promotional-popup')) {
    customElements.define('promotional-popup', PromotionalPopup);
}
